module.exports = __webpack_public_path__ + "static/media/Rajlaxmi.e23b9337.png";